import { Box, styled } from '@mui/material'
import { Link } from 'react-router-dom'

export const HeaderNavbarRoot = styled(Box)(({ theme }) => ({
  left: 0,
  minHeight: '70px',
  width: '100%',
  top: 0,
  backgroundColor: theme.palette.white.main,
  padding: '5px 16px',
  display: 'flex',
  alignContent: 'center',
  zIndex: 1000,

  [theme.breakpoints.down('lg')]: {
    width: '100vw',
    padding: `max(5px, ${theme.customVariables.safeAreaInsetTop}) max(16px, ${theme.customVariables.safeAreaInsetRight}) 5px max(16px, ${theme.customVariables.safeAreaInsetLeft})`
  }
}))

export const HeaderNavbarAvatarWrapper = styled(Box)(({ theme }) => ({
  width: '200px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width'], {
    duration: theme.transitions.duration.short,
    easing: 'ease-in-out'
  })
}))
export const HeaderNavbarAvatarLink = styled(Link)(({ theme }) => ({
  width: '200px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  color: theme.palette.text.primary,
  transition: theme.transitions.create(['width'], {
    duration: theme.transitions.duration.short,
    easing: 'ease-in-out'
  })
}))
